import React from 'react';
import {
  Text,
  Group,
  Stack,
  Container,
  Title,
  Badge,
} from '@mantine/core';
import SpotifyButton from './SpotifyButton';
import Link from './Link';

function HomePagePricing(props) {

  const {
    spotifyAuthUrl,
  } = props;

  return (
    <Container p='xl' pb={80}>
      <Group mt='md' mb='xs' spacing='xs'>
        <Title size='h3' order={2}>
          <Text span c='gray.5' strikethrough mr={6} inherit>$15</Text>
          $10 per game
        </Title>
        <Badge color='teal' style={{ textTransform: 'none' }} fz={12} fw={600}>Limited offer</Badge>
      </Group>
      <Text
        color='gray.7'
        mb='xl'
      >
        Pay as you go – no subscription needed. Payments processed securely using <Link href='https://www.stripe.com' newTab>Stripe</Link>. 
      </Text>
      <Stack align='flex-start' spacing='sm'>
        <SpotifyButton href={spotifyAuthUrl} />
      </Stack>
    </Container>
  )
};

export default HomePagePricing;